import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { PrismicProvider } from '@prismicio/react';
import { client } from './prismic';


class BlogApp extends HTMLElement {

  connectedCallback() {


    const mountPoint = this.querySelector(".blog-app") || document.createElement("div");
    mountPoint.classList.add(".blog-app");

    this.appendChild(mountPoint);

    const root = ReactDOM.createRoot(mountPoint);
    root.render(
		<React.StrictMode>
			<PrismicProvider client={client}>
				<App />
			</PrismicProvider>
		</React.StrictMode>,
    );
  }
}

customElements.define("blog-app", BlogApp);

